// extracted by mini-css-extract-plugin
module.exports = {"carousel":"styles_carousel__XJyjB","dragging":"styles_dragging__VgCQG"};